import {config} from './init/index';

export default function getConfig(parameter) {
  let conf = null;
  if (conf == null) conf = config.default;
  return conf[parameter];
}
